import { render, staticRenderFns } from "./TablaEvento.vue?vue&type=template&id=a50ef60a"
import script from "./TablaEvento.vue?vue&type=script&lang=js"
export * from "./TablaEvento.vue?vue&type=script&lang=js"
import style0 from "./TablaEvento.vue?vue&type=style&index=0&id=a50ef60a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports